<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/XztRR7/images/e9781439629895_cover.jpg?1684515198035" alt="This image is the cover for the book Winter Park in Vintage Postcards, Postcard History Series"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Winter Park in Vintage Postcards, Postcard History Series
      </h1>
      <p class="bookDescription body article font2">
        <p>�The perfume of the orange blossoms . . . the beauty of every scene, combine to make me wonder whether I am not in Paradise,� wrote one visitor to Winter Park, Florida, in 1918. Just five miles north of Orlando, Winter Park�s oak-lined brick streets and its quiet lakes have been attracting visitors since the late 19th century, when U.S. president Chester A. Arthur declared, �This is the prettiest spot I have seen in Florida.� The New England�like city in the heart of the subtropics was once home to the Seminole Hotel, the largest resort south of Jacksonville. In 1885, prestigious Rollins College was founded here, the first institution of higher learning in Florida.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Robin Chapman
      </h2>
      
      <p class="authorDescription body article">Author Robin Chapman, a longtime television journalist who now calls Winter Park home, tells the city�s story through a collection of vintage postcards. As the tale unfolds, readers will see that Winter Park�s past is a prelude to Central Florida�s lively present as the number-one vacation destination in the world.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Arcadia Publishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?272c1476